import { z } from 'zod/v4';

import { endpoint } from '../http/endpoint';
import {
    AvnetSilicaV3CredentialsInputDTORuntype,
    AvnetSilicaV3ResponseBodyDTORuntype,
} from './avnetSilicaV3BackendTypes';

export const avnetSilicaV3Endpoints = {
    'GET /3rdparty/avnetsilicav3/credentials': endpoint({
        description: 'Returns credentials for Avnet Silica V3 integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: AvnetSilicaV3ResponseBodyDTORuntype,
    }),
    'POST /3rdparty/avnetsilicav3/credentials': endpoint({
        description: 'Uploads credentials for Avnet Silica V3 API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: AvnetSilicaV3CredentialsInputDTORuntype,
        responseBody: AvnetSilicaV3ResponseBodyDTORuntype,
        invalidates: ['GET /3rdparty/avnetsilicav3/credentials'],
    }),
    'PATCH /3rdparty/avnetsilicav3/credentials': endpoint({
        description: 'Updates credentials for Avnet Silica V3 API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: AvnetSilicaV3CredentialsInputDTORuntype,
        responseBody: AvnetSilicaV3ResponseBodyDTORuntype,
        invalidates: ['GET /3rdparty/avnetsilicav3/credentials'],
    }),
    'DELETE /3rdparty/avnetsilicav3/credentials': endpoint({
        description: 'Deletes existing credentials for Avnet Silica V3 API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.object({ deleted: z.number() }),
        invalidates: ['GET /3rdparty/avnetsilicav3/credentials'],
    }),
};
